<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-form label-width="200px" class="mt30">
      <el-form-item label="追踪广告展示次数上限：">
        <el-input v-model="formData.traceLimit" type="number" style="width: 300px;" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="拆红包付费规则：">
        <el-button type="primary" @click="editBtn(1)">添加</el-button>
        <el-table class="my-table mt10" :data="formData.adRedPacketRuleFormList" v-loading="tableLoading"
                  :header-row-class-name="'my-table-header'" style="width: 800px;">
          <el-table-column align="center" prop="ruleName" label="规则名称"></el-table-column>
          <el-table-column align="center" label="空包率">
            <template slot-scope="{row}">
              {{row.emptyRate}}%
            </template>
          </el-table-column>
          <el-table-column align="center" label="金额范围">
            <template slot-scope="{row}">
              {{row.minAmount}}
              {{row.maxAmount}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="" width="120" label="操作">
            <template slot-scope="scope">
              <a class="glob-a" @click="editBtn(2, scope.row)">编辑</a>
              <a class="glob-a" @click="editBtn(3, scope.row, scope.$index)">删除</a>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="拆红包平台费用比例：">
        <el-input v-model="formData.platformBenefitRate" type="number" style="width: 300px;" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="内容广告作者分成比例：">
        <el-input v-model="formData.authorBenefitRate" type="number" style="width: 300px;" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="分享人分成比例：">
        <el-input v-model="formData.sharePeopleBenefitRate" type="number" style="width: 300px;" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="点击付费单价：">
        <el-input v-model="formData.clickPay" type="number" style="width: 300px;" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="视频类广告观看进度设置：">
        <el-input v-model="formData.videoProgress" type="number" style="width: 300px;" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="非视频类广告浏览高度设置：">
        <el-input v-model="formData.viewHeight" type="number" style="width: 300px;" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="客户表单信息：">
        <el-checkbox-group v-model="formData.adVisitorInfoFieldList">
          <el-checkbox v-for="(item, index) in adVisitorInfoFieldList" :key="index" :label="item.adVisitorInfoFieldId">
            {{item.fieldName}}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button class="mt30" type="primary" size="medium" @click="save">保存设置</el-button>
      </el-form-item>
    </el-form>

    <!-- 审核 -->
    <el-dialog title="审核" :visible.sync="addData.modal" width="500px">
      <el-form ref="refFormAdd" :rules="rules" :model="addData" label-width="120px">
        <el-form-item label="规则名称：" prop="ruleName">
          <el-input v-model="addData.ruleName"></el-input>
        </el-form-item>
        <el-form-item label="空包率：" prop="emptyRate">
          <el-input v-model="addData.emptyRate">
            <span slot="suffix" class="el-input__icon">%</span>
          </el-input>
        </el-form-item>
        <el-form-item label="金额范围：" prop="minAmount">
          <el-input-number v-model="addData.minAmount" :min="0" :controls="false"/>
          <span class="pl5 pr5">-</span>
          <el-input-number v-model="addData.maxAmount" :min="addData.minAmount" :controls="false"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="addData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getAdSettings,
    setAdSettings
  } from '@/api'

  export default {
    name: 'AdSettings',
    data () {
      const sumValidate = (rule, value, callback) => {
        if (this.addData.minAmount >= 0 && this.addData.maxAmount >= 0) {
          callback()
        } else {
          callback(new Error('此输入框必填'))
        }
      }

      return {
        rules: {
          emptyRate: this.$store.state.rules.required,
          ruleName: this.$store.state.rules.required,
          minAmount: {validator: sumValidate, trigger: 'blur'},
        },
        formData: {
          adRedPacketRuleFormList: [],
          adVisitorInfoFieldList: [],
          authorBenefitRate: '',
          clickPay: '',
          platformBenefitRate: '',
          sharePeopleBenefitRate: '',
          traceLimit: '',
          videoProgress: '',
          viewHeight: '',
          delAdRedPacketRuleIdList: []
        },
        adVisitorInfoFieldList: [],
        tableLoading: false,
        addData: {
          modal: false,
          add: 1,
          adRedPacketRuleId: '',
          emptyRate: '',
          ruleName: '',
          maxAmount: '',
          minAmount: '',
        }
      }
    },
    created () {
      this.getAdSettingsFn()
    },
    methods: {
      save () {
        setAdSettings(this.formData).then(res => {
          this.$message.success(res.data)
          this.getAdSettingsFn()
        })
      },
      addSave () {
        this.$refs['refFormAdd'].validate(valid => {
          if (valid) {
            if (this.addData.add === 1) {
              this.formData.adRedPacketRuleFormList.push({
                emptyRate: this.addData.emptyRate,
                ruleName: this.addData.ruleName,
                maxAmount: this.addData.maxAmount,
                minAmount: this.addData.minAmount,
                adRedPacketRuleId: this.addData.adRedPacketRuleId
              })
            } else {
              this.formData.adRedPacketRuleFormList.forEach(item => {
                if (item.adRedPacketRuleId == this.addData.adRedPacketRuleId) {
                  item.emptyRate = this.addData.emptyRate
                  item.ruleName = this.addData.ruleName
                  item.maxAmount = this.addData.maxAmount
                  item.minAmount = this.addData.minAmount
                }
              })
            }

            this.addData.modal = false
          } else {
            return false
          }
        })
      },
      editBtn (t, row, index) {
        switch (t) {
          case 1:
            this.addData = {
              modal: true,
              add: 1,
              emptyRate: '',
              ruleName: '',
              maxAmount: 0,
              minAmount: 0,
              adRedPacketRuleId: ''
            }
            break
          case 2:
            this.addData = {
              modal: true,
              add: 2,
              emptyRate: row.emptyRate,
              ruleName: row.ruleName,
              maxAmount: Number(row.maxAmount),
              minAmount: Number(row.minAmount),
              adRedPacketRuleId: row.adRedPacketRuleId
            }
            break
          case 3:
            row.adRedPacketRuleId && this.formData.delAdRedPacketRuleIdList.push(row.adRedPacketRuleId)
            this.formData.adRedPacketRuleFormList.splice(index, 1)
            break
        }
      },
      getAdSettingsFn () {
        getAdSettings().then(res => {
          let temp = Object.assign({}, res.data)
          this.adVisitorInfoFieldList = temp.adVisitorInfoFieldList

          this.formData = {
            adRedPacketRuleFormList: temp.adRedPacketRuleList,
            adVisitorInfoFieldList: temp.adVisitorInfoFieldList.filter(item => item.usedFlag === 'Y').map(item => item.adVisitorInfoFieldId),
            authorBenefitRate: temp.authorBenefitRate,
            clickPay: temp.clickPay,
            platformBenefitRate: temp.platformBenefitRate,
            sharePeopleBenefitRate: temp.sharePeopleBenefitRate,
            traceLimit: temp.traceLimit,
            videoProgress: temp.videoProgress,
            viewHeight: temp.viewHeight,
            delAdRedPacketRuleIdList: []
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
